export default ({ store }) => {
  if (!store.getters['features/loaded']) {
    return store.dispatch('features/loadDisabledFeatures')
  }
}
